import { render, staticRenderFns } from "./BundleItemCard.vue?vue&type=template&id=f7edd2fe&scoped=true&"
import script from "./BundleItemCard.vue?vue&type=script&lang=js&"
export * from "./BundleItemCard.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemCard.vue?vue&type=style&index=0&id=f7edd2fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7edd2fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VImg})
